var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var _isResolved, _isRejected, _isCancelled, _cancelHandlers, _promise, _resolve, _reject;
import axios from "axios";
class BaseHttpRequest {
  constructor(config) {
    __publicField(this, "config");
    this.config = config;
  }
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var browser = typeof self == "object" ? self.FormData : window.FormData;
const FormData = /* @__PURE__ */ getDefaultExportFromCjs(browser);
class ApiError extends Error {
  constructor(request2, response, message) {
    super(message);
    __publicField(this, "url");
    __publicField(this, "status");
    __publicField(this, "statusText");
    __publicField(this, "body");
    __publicField(this, "request");
    this.name = "ApiError";
    this.url = response.url;
    this.status = response.status;
    this.statusText = response.statusText;
    this.body = response.body;
    this.request = request2;
  }
}
class CancelError extends Error {
  constructor(message) {
    super(message);
    this.name = "CancelError";
  }
  get isCancelled() {
    return true;
  }
}
class CancelablePromise {
  constructor(executor) {
    __privateAdd(this, _isResolved, void 0);
    __privateAdd(this, _isRejected, void 0);
    __privateAdd(this, _isCancelled, void 0);
    __privateAdd(this, _cancelHandlers, void 0);
    __privateAdd(this, _promise, void 0);
    __privateAdd(this, _resolve, void 0);
    __privateAdd(this, _reject, void 0);
    __privateSet(this, _isResolved, false);
    __privateSet(this, _isRejected, false);
    __privateSet(this, _isCancelled, false);
    __privateSet(this, _cancelHandlers, []);
    __privateSet(this, _promise, new Promise((resolve2, reject) => {
      __privateSet(this, _resolve, resolve2);
      __privateSet(this, _reject, reject);
      const onResolve = (value) => {
        var _a;
        if (__privateGet(this, _isResolved) || __privateGet(this, _isRejected) || __privateGet(this, _isCancelled)) {
          return;
        }
        __privateSet(this, _isResolved, true);
        (_a = __privateGet(this, _resolve)) == null ? void 0 : _a.call(this, value);
      };
      const onReject = (reason) => {
        var _a;
        if (__privateGet(this, _isResolved) || __privateGet(this, _isRejected) || __privateGet(this, _isCancelled)) {
          return;
        }
        __privateSet(this, _isRejected, true);
        (_a = __privateGet(this, _reject)) == null ? void 0 : _a.call(this, reason);
      };
      const onCancel = (cancelHandler) => {
        if (__privateGet(this, _isResolved) || __privateGet(this, _isRejected) || __privateGet(this, _isCancelled)) {
          return;
        }
        __privateGet(this, _cancelHandlers).push(cancelHandler);
      };
      Object.defineProperty(onCancel, "isResolved", {
        get: () => __privateGet(this, _isResolved)
      });
      Object.defineProperty(onCancel, "isRejected", {
        get: () => __privateGet(this, _isRejected)
      });
      Object.defineProperty(onCancel, "isCancelled", {
        get: () => __privateGet(this, _isCancelled)
      });
      return executor(onResolve, onReject, onCancel);
    }));
  }
  get [Symbol.toStringTag]() {
    return "Cancellable Promise";
  }
  then(onFulfilled, onRejected) {
    return __privateGet(this, _promise).then(onFulfilled, onRejected);
  }
  catch(onRejected) {
    return __privateGet(this, _promise).catch(onRejected);
  }
  finally(onFinally) {
    return __privateGet(this, _promise).finally(onFinally);
  }
  cancel() {
    var _a;
    if (__privateGet(this, _isResolved) || __privateGet(this, _isRejected) || __privateGet(this, _isCancelled)) {
      return;
    }
    __privateSet(this, _isCancelled, true);
    if (__privateGet(this, _cancelHandlers).length) {
      try {
        for (const cancelHandler of __privateGet(this, _cancelHandlers)) {
          cancelHandler();
        }
      } catch (error) {
        console.warn("Cancellation threw an error", error);
        return;
      }
    }
    __privateGet(this, _cancelHandlers).length = 0;
    (_a = __privateGet(this, _reject)) == null ? void 0 : _a.call(this, new CancelError("Request aborted"));
  }
  get isCancelled() {
    return __privateGet(this, _isCancelled);
  }
}
_isResolved = new WeakMap();
_isRejected = new WeakMap();
_isCancelled = new WeakMap();
_cancelHandlers = new WeakMap();
_promise = new WeakMap();
_resolve = new WeakMap();
_reject = new WeakMap();
const isDefined = (value) => {
  return value !== void 0 && value !== null;
};
const isString = (value) => {
  return typeof value === "string";
};
const isStringWithValue = (value) => {
  return isString(value) && value !== "";
};
const isBlob = (value) => {
  return typeof value === "object" && typeof value.type === "string" && typeof value.stream === "function" && typeof value.arrayBuffer === "function" && typeof value.constructor === "function" && typeof value.constructor.name === "string" && /^(Blob|File)$/.test(value.constructor.name) && /^(Blob|File)$/.test(value[Symbol.toStringTag]);
};
const isFormData = (value) => {
  return value instanceof FormData;
};
const isSuccess = (status) => {
  return status >= 200 && status < 300;
};
const base64 = (str) => {
  try {
    return btoa(str);
  } catch (err) {
    return Buffer.from(str).toString("base64");
  }
};
const getQueryString = (params) => {
  const qs = [];
  const append = (key, value) => {
    qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  };
  const process = (key, value) => {
    if (isDefined(value)) {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          process(key, v);
        });
      } else if (typeof value === "object") {
        Object.entries(value).forEach(([k, v]) => {
          process(`${key}[${k}]`, v);
        });
      } else {
        append(key, value);
      }
    }
  };
  Object.entries(params).forEach(([key, value]) => {
    process(key, value);
  });
  if (qs.length > 0) {
    return `?${qs.join("&")}`;
  }
  return "";
};
const getUrl = (config, options) => {
  const encoder = config.ENCODE_PATH || encodeURI;
  const path = options.url.replace("{api-version}", config.VERSION).replace(/{(.*?)}/g, (substring, group) => {
    var _a;
    if ((_a = options.path) == null ? void 0 : _a.hasOwnProperty(group)) {
      return encoder(String(options.path[group]));
    }
    return substring;
  });
  const url = `${config.BASE}${path}`;
  if (options.query) {
    return `${url}${getQueryString(options.query)}`;
  }
  return url;
};
const getFormData = (options) => {
  if (options.formData) {
    const formData = new FormData();
    const process = (key, value) => {
      if (isString(value) || isBlob(value)) {
        formData.append(key, value);
      } else {
        formData.append(key, JSON.stringify(value));
      }
    };
    Object.entries(options.formData).filter(([_, value]) => isDefined(value)).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => process(key, v));
      } else {
        process(key, value);
      }
    });
    return formData;
  }
  return void 0;
};
const resolve = async (options, resolver) => {
  if (typeof resolver === "function") {
    return resolver(options);
  }
  return resolver;
};
const getHeaders = async (config, options, formData) => {
  const token = await resolve(options, config.TOKEN);
  const username = await resolve(options, config.USERNAME);
  const password = await resolve(options, config.PASSWORD);
  const additionalHeaders = await resolve(options, config.HEADERS);
  const formHeaders = typeof (formData == null ? void 0 : formData.getHeaders) === "function" && (formData == null ? void 0 : formData.getHeaders()) || {};
  const headers = Object.entries({
    Accept: "application/json",
    ...additionalHeaders,
    ...options.headers,
    ...formHeaders
  }).filter(([_, value]) => isDefined(value)).reduce((headers2, [key, value]) => ({
    ...headers2,
    [key]: String(value)
  }), {});
  if (isStringWithValue(token)) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  if (isStringWithValue(username) && isStringWithValue(password)) {
    const credentials = base64(`${username}:${password}`);
    headers["Authorization"] = `Basic ${credentials}`;
  }
  if (options.body) {
    if (options.mediaType) {
      headers["Content-Type"] = options.mediaType;
    } else if (isBlob(options.body)) {
      headers["Content-Type"] = options.body.type || "application/octet-stream";
    } else if (isString(options.body)) {
      headers["Content-Type"] = "text/plain";
    } else if (!isFormData(options.body)) {
      headers["Content-Type"] = "application/json";
    }
  }
  return headers;
};
const getRequestBody = (options) => {
  if (options.body) {
    return options.body;
  }
  return void 0;
};
const sendRequest = async (config, options, url, body, formData, headers, onCancel, axiosClient) => {
  const source = axios.CancelToken.source();
  const requestConfig = {
    url,
    headers,
    data: body ?? formData,
    method: options.method,
    withCredentials: config.WITH_CREDENTIALS,
    cancelToken: source.token
  };
  onCancel(() => source.cancel("The user aborted a request."));
  try {
    return await axiosClient.request(requestConfig);
  } catch (error) {
    const axiosError = error;
    if (axiosError.response) {
      return axiosError.response;
    }
    throw error;
  }
};
const getResponseHeader = (response, responseHeader) => {
  if (responseHeader) {
    const content = response.headers[responseHeader];
    if (isString(content)) {
      return content;
    }
  }
  return void 0;
};
const getResponseBody = (response) => {
  if (response.status !== 204) {
    return response.data;
  }
  return void 0;
};
const catchErrorCodes = (options, result) => {
  const errors = {
    400: "Bad Request",
    401: "Unauthorized",
    403: "Forbidden",
    404: "Not Found",
    500: "Internal Server Error",
    502: "Bad Gateway",
    503: "Service Unavailable",
    ...options.errors
  };
  const error = errors[result.status];
  if (error) {
    throw new ApiError(options, result, error);
  }
  if (!result.ok) {
    const errorStatus = result.status ?? "unknown";
    const errorStatusText = result.statusText ?? "unknown";
    const errorBody = (() => {
      try {
        return JSON.stringify(result.body, null, 2);
      } catch (e) {
        return void 0;
      }
    })();
    throw new ApiError(options, result, `Generic Error: status: ${errorStatus}; status text: ${errorStatusText}; body: ${errorBody}`);
  }
};
const request = (config, options, axiosClient = axios) => {
  return new CancelablePromise(async (resolve2, reject, onCancel) => {
    try {
      const url = getUrl(config, options);
      const formData = getFormData(options);
      const body = getRequestBody(options);
      const headers = await getHeaders(config, options, formData);
      if (!onCancel.isCancelled) {
        const response = await sendRequest(config, options, url, body, formData, headers, onCancel, axiosClient);
        const responseBody = getResponseBody(response);
        const responseHeader = getResponseHeader(response, options.responseHeader);
        const result = {
          url,
          ok: isSuccess(response.status),
          status: response.status,
          statusText: response.statusText,
          body: responseHeader ?? responseBody
        };
        catchErrorCodes(options, result);
        resolve2(result.body);
      }
    } catch (error) {
      reject(error);
    }
  });
};
class AxiosHttpRequest extends BaseHttpRequest {
  constructor(config) {
    super(config);
  }
  /**
   * Request method
   * @param options The request options from the service
   * @returns CancelablePromise<T>
   * @throws ApiError
   */
  request(options) {
    return request(this.config, options);
  }
}
class ActivitiesEndpointsService {
  constructor(httpRequest) {
    __publicField(this, "httpRequest");
    this.httpRequest = httpRequest;
  }
  /**
   * @param activityId
   * @returns any OK
   * @throws ApiError
   */
  activitiesDelete(activityId) {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/activities/{activityId}",
      path: {
        "activityId": activityId
      }
    });
  }
  /**
   * @param carId
   * @returns ActivityGetDto OK
   * @throws ApiError
   */
  activitiesGetCarActivities(carId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/activities",
      path: {
        "carId": carId
      }
    });
  }
  /**
   * @param dealerId
   * @param startDate
   * @param endDate
   * @returns ActivityGetDto OK
   * @throws ApiError
   */
  activitiesGetDealerActivitiesForPeriod(dealerId, startDate, endDate) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/activities",
      path: {
        "dealerId": dealerId
      },
      query: {
        "startDate": startDate,
        "endDate": endDate
      }
    });
  }
  /**
   * @param userId
   * @param startDate
   * @param endDate
   * @returns ActivityGetDto OK
   * @throws ApiError
   */
  activitiesGetUserActivitiesForPeriod(userId, startDate, endDate) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/users/{userId}/activities",
      path: {
        "userId": userId
      },
      query: {
        "startDate": startDate,
        "endDate": endDate
      }
    });
  }
  /**
   * @param requestBody
   * @returns ActivityGetDto OK
   * @throws ApiError
   */
  activitiesPost(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/activities",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
}
class AuthEndpointsService {
  constructor(httpRequest) {
    __publicField(this, "httpRequest");
    this.httpRequest = httpRequest;
  }
  /**
   * @returns string OK
   * @throws ApiError
   */
  authRefreshToken() {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/auth/refreshtoken"
    });
  }
}
class CarsEndpointsService {
  constructor(httpRequest) {
    __publicField(this, "httpRequest");
    this.httpRequest = httpRequest;
  }
  /**
   * @param keyword
   * @param searchBy
   * @param includeOutOfInventory
   * @param includeAllDealers
   * @returns any OK
   * @throws ApiError
   */
  carsGetFindResults(keyword, searchBy, includeOutOfInventory, includeAllDealers) {
    return this.httpRequest.request({
      method: "GET",
      url: "/car/find/results",
      query: {
        "SearchBy": searchBy,
        "Keyword": keyword,
        "IncludeOutOfInventory": includeOutOfInventory,
        "IncludeAllDealers": includeAllDealers
      }
    });
  }
  /**
   * @param manufacturerId
   * @returns string OK
   * @throws ApiError
   */
  carsGetBaseModels(manufacturerId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/basemodels/{manufacturerId}",
      path: {
        "manufacturerId": manufacturerId
      }
    });
  }
  /**
   * @param dealerId
   * @param stockNumber
   * @returns string OK
   * @throws ApiError
   */
  carsGetCarsWithStockNumberByDealer(dealerId, stockNumber) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/cars/{stockNumber}",
      path: {
        "dealerId": dealerId,
        "stockNumber": stockNumber
      }
    });
  }
  /**
   * @param dealerId
   * @param stockNumber
   * @returns CarStockNumberUsageDto OK
   * @throws ApiError
   */
  carsGetStockNumberUsage(dealerId, stockNumber) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/stocknumbers/{stockNumber}",
      path: {
        "dealerId": dealerId,
        "stockNumber": stockNumber
      }
    });
  }
  /**
   * @param dealerId
   * @param stockNumber
   * @returns boolean OK
   * @throws ApiError
   */
  carsGetStockNumberInUse(dealerId, stockNumber) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/stocknumbers/{stockNumber}/inuse",
      path: {
        "dealerId": dealerId,
        "stockNumber": stockNumber
      }
    });
  }
  /**
   * @param dealerId
   * @returns CarGetDto OK
   * @throws ApiError
   */
  carsGetCarsInInventoryByDealer(dealerId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/cars",
      path: {
        "dealerId": dealerId
      }
    });
  }
  /**
   * @param dealerId
   * @param vin
   * @returns CarGetDetailsDto OK
   * @throws ApiError
   */
  carsGetCarDetailsByDealer(dealerId, vin) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/cars/{vin}/details",
      path: {
        "dealerId": dealerId,
        "vin": vin
      }
    });
  }
  /**
   * @param manufacturerId
   * @param baseModel
   * @returns CarTrimsDto OK
   * @throws ApiError
   */
  carsGetTrims(manufacturerId, baseModel) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/trims/{manufacturerId}/{baseModel}",
      path: {
        "manufacturerId": manufacturerId,
        "baseModel": baseModel
      }
    });
  }
  /**
   * @param carId
   * @returns CarGetDto OK
   * @throws ApiError
   */
  carsGet(carId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}",
      path: {
        "carId": carId
      }
    });
  }
  /**
   * @param carId
   * @returns CarDeleteDto OK
   * @throws ApiError
   */
  carsDelete(carId) {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/cars/{carId}",
      path: {
        "carId": carId
      }
    });
  }
  /**
   * @param carId
   * @param requestBody
   * @returns CarGetDto OK
   * @throws ApiError
   */
  carsPatch(carId, requestBody) {
    return this.httpRequest.request({
      method: "PATCH",
      url: "/api/cars/{carId}",
      path: {
        "carId": carId
      },
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param carId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  carsPut(carId, requestBody) {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/cars/{carId}",
      path: {
        "carId": carId
      },
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @returns ColorGetDto OK
   * @throws ApiError
   */
  carsGetColorOptions() {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/coloroptions"
    });
  }
  /**
   * @param carId
   * @returns boolean OK
   * @throws ApiError
   */
  carsHasOptions(carId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/hasoptions",
      query: {
        "carId": carId
      }
    });
  }
  /**
   * @param requestBody
   * @returns CarGetDto OK
   * @throws ApiError
   */
  carsPostFromDecodedData(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/cars/fromdecodeddata",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns CarPostBasicResultDto OK
   * @throws ApiError
   */
  carsPostNew(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/cars/new",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param carId
   * @param vehicleId
   * @param transmission
   * @returns TryOptionsUpdateResultDto OK
   * @throws ApiError
   */
  carsTryUpdateOptionsFromDataOne(carId, vehicleId, transmission) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/tryupdateoptionsfromdatatone/{carId}",
      path: {
        "carId": carId
      },
      query: {
        "vehicleId": vehicleId,
        "transmission": transmission
      }
    });
  }
  /**
   * Re-adds a car to inventory optionally changing its stock number
   * @param carId
   * @param stockNumber
   * @returns any OK
   * @throws ApiError
   */
  carsReAddToInventory(carId, stockNumber) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/readdtoinventory/{carId}",
      path: {
        "carId": carId
      },
      query: {
        "stockNumber": stockNumber
      }
    });
  }
  /**
   * Restores a car to inventory
   * Restores a car to inventory using its VIN and stock number
   * @param vin
   * @param stockNumber
   * @returns CarGetDto OK
   * @throws ApiError
   */
  carsRestoreToInventory(vin, stockNumber) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/restoretoinventory/{vin}",
      path: {
        "vin": vin
      },
      query: {
        "stockNumber": stockNumber
      }
    });
  }
  /**
   * @param carId
   * @returns any OK
   * @throws ApiError
   */
  carsRemoveFromInventory(carId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/removefrominventory/{carId}",
      path: {
        "carId": carId
      }
    });
  }
  /**
   * @param carId
   * @returns any OK
   * @throws ApiError
   */
  carsRegenerateVideo(carId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/regeneratevideo/{carId}",
      path: {
        "carId": carId
      }
    });
  }
  /**
   * @param carId
   * @returns string OK
   * @throws ApiError
   */
  carsDeleteVideo(carId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/deletevideo/{carId}",
      path: {
        "carId": carId
      }
    });
  }
}
class DataOneEndpointsService {
  constructor(httpRequest) {
    __publicField(this, "httpRequest");
    this.httpRequest = httpRequest;
  }
  /**
   * @param vin
   * @returns DataOneDecodeResponseDto OK
   * @throws ApiError
   */
  dataOneDecodeGet(vin) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dataone/decode",
      query: {
        "vin": vin
      }
    });
  }
  /**
   * @param vin
   * @returns DataOneDecodeResponseDto OK
   * @throws ApiError
   */
  dataOneDecodePost(vin) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/dataone/decode",
      query: {
        "vin": vin
      }
    });
  }
}
class DealersEndpointsService {
  constructor(httpRequest) {
    __publicField(this, "httpRequest");
    this.httpRequest = httpRequest;
  }
  /**
   * @param dealerId
   * @returns DealerGetDto OK
   * @throws ApiError
   */
  dealersGet(dealerId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}",
      path: {
        "dealerId": dealerId
      }
    });
  }
  /**
   * @param dealerId
   * @returns DealerCarMediaCopyMatchesPostResponseDto OK
   * @throws ApiError
   */
  dealersGetCarMediaCopyMatches(dealerId) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/dealers/{dealerId}/cars/mediacopymatches",
      path: {
        "dealerId": dealerId
      }
    });
  }
  /**
   * @param dealerId
   * @returns DealerGetMediaManagerSettingsDto OK
   * @throws ApiError
   */
  dealersGetMediaManagerSettings(dealerId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/mediamanagersettings",
      path: {
        "dealerId": dealerId
      }
    });
  }
  /**
   * @param dealerId
   * @returns DealerGetServiceRateDto OK
   * @throws ApiError
   */
  dealersGetServiceRates(dealerId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/servicerates",
      path: {
        "dealerId": dealerId
      }
    });
  }
  /**
   * @param dealerId
   * @returns DealerGetStickerTypeDto OK
   * @throws ApiError
   */
  dealersGetStickerTypes(dealerId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/stickertypes",
      path: {
        "dealerId": dealerId
      }
    });
  }
  /**
   * @param dealerId
   * @param requestBody
   * @returns string OK
   * @throws ApiError
   */
  dealersPostCarClone(dealerId, requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/dealers/{dealerId}/cars/clone",
      path: {
        "dealerId": dealerId
      },
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
}
class MediaCopierSettingsEndpointsService {
  constructor(httpRequest) {
    __publicField(this, "httpRequest");
    this.httpRequest = httpRequest;
  }
  /**
   * @param userId
   * @param dealerId
   * @returns MediaCopierSettingsGetDto OK
   * @throws ApiError
   */
  mediaCopierSettingsGet(userId, dealerId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/mediacopiersettings",
      query: {
        "userId": userId,
        "dealerId": dealerId
      }
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  mediaCopierSettingsPatch(requestBody) {
    return this.httpRequest.request({
      method: "PATCH",
      url: "/api/mediacopiersettings",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
}
class MediaUploadEndpointsService {
  constructor(httpRequest) {
    __publicField(this, "httpRequest");
    this.httpRequest = httpRequest;
  }
  /**
   * @returns MediaUploadSetWithUnassignedMediaDto OK
   * @throws ApiError
   */
  mediaUploadGetUserUploadsWithUnassignedMedia() {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/mediaupload/currentuserswithunassignedmedia"
    });
  }
  /**
   * @param requestBody
   * @returns MediaUploadSetDto OK
   * @throws ApiError
   */
  mediaUploadPost(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/mediaupload",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns MediaUploadSetDto OK
   * @throws ApiError
   */
  mediaUploadPut(requestBody) {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/mediaupload",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * Warning: Id in route and S3Path in dto are unused but preserved for consistency.
   * @param uploadSetId
   * @returns any OK
   * @throws ApiError
   */
  mediaUploadSortItems(uploadSetId) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/mediaupload/{uploadSetId}/sortitems",
      path: {
        "uploadSetId": uploadSetId
      }
    });
  }
  /**
   * @param uploadSetId
   * @returns MediaUploadItemResponseDto OK
   * @throws ApiError
   */
  mediaUploadUnassignedItems(uploadSetId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/mediaupload/{uploadSetId}/unassigneditems",
      path: {
        "uploadSetId": uploadSetId
      }
    });
  }
}
class MediaUploadItemEndpointsService {
  constructor(httpRequest) {
    __publicField(this, "httpRequest");
    this.httpRequest = httpRequest;
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  mediaUploadItemBatchDelete(requestBody) {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/mediauploaditem/batch",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param id
   * @returns any OK
   * @throws ApiError
   */
  mediaUploadItemDelete(id) {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/mediauploaditem/{id}",
      path: {
        "id": id
      }
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  mediaUploadItemDeleteAlternate(requestBody) {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/mediauploaditem/delete",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  mediaUploadItemDeleteAlternatePost(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/mediauploaditem/delete",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param formData
   * @returns any OK
   * @throws ApiError
   */
  mediaUploadItemPost(formData) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/mediauploaditem",
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  mediaUploadItemPreflightUpload(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/mediauploaditem/preflightupload",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
}
class NotShotEndpointsService {
  constructor(httpRequest) {
    __publicField(this, "httpRequest");
    this.httpRequest = httpRequest;
  }
  /**
   * @returns CarNotShotReasonDto OK
   * @throws ApiError
   */
  notShotGetNotShotReasons() {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/notshot/reasons"
    });
  }
  /**
   * @param dealerId
   * @returns CarNotShotGetDto OK
   * @throws ApiError
   */
  notShotGetDealerNotShots(dealerId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/notshots",
      path: {
        "dealerId": dealerId
      }
    });
  }
  /**
   * @param carId
   * @returns CarNotShotGetDto OK
   * @throws ApiError
   */
  notShotGet(carId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/notshot/{carId}",
      path: {
        "carId": carId
      }
    });
  }
  /**
   * @param carId
   * @param requestBody
   * @returns CarNotShotPutDto OK
   * @throws ApiError
   */
  notShotPut(carId, requestBody) {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/notshot/{carId}",
      path: {
        "carId": carId
      },
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns CarNotShotPutDto OK
   * @throws ApiError
   */
  notShotPatch(requestBody) {
    return this.httpRequest.request({
      method: "PATCH",
      url: "/api/notshot",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
}
class OptionsEndpointsService {
  constructor(httpRequest) {
    __publicField(this, "httpRequest");
    this.httpRequest = httpRequest;
  }
  /**
   * @param carId
   * @returns CarOptionGetDto OK
   * @throws ApiError
   */
  optionsGetCarOptions(carId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/options",
      path: {
        "carId": carId
      }
    });
  }
  /**
   * @param carId
   * @returns number OK
   * @throws ApiError
   */
  optionsClearCarOptions(carId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/options/clear",
      path: {
        "carId": carId
      }
    });
  }
}
class PaperTrailEndpointsService {
  constructor(httpRequest) {
    __publicField(this, "httpRequest");
    this.httpRequest = httpRequest;
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  paperTrailAlert(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/papertrail/alert",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  paperTrailCritical(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/papertrail/critical",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  paperTrailDebug(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/papertrail/debug",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  paperTrailError(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/papertrail/error",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  paperTrailInfo(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/papertrail/info",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  paperTrailLog(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/papertrail/log",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  paperTrailWarn(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/papertrail/warn",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
}
class PhotoEndpointsService {
  constructor(httpRequest) {
    __publicField(this, "httpRequest");
    this.httpRequest = httpRequest;
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  photosBatch(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/photos/batch",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param photoId
   * @returns PhotoGetDto OK
   * @throws ApiError
   */
  photosGet(photoId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/photos/{photoId}",
      path: {
        "photoId": photoId
      }
    });
  }
  /**
   * @param carId
   * @returns PhotoDto OK
   * @throws ApiError
   */
  photosGetPhotosByCarId(carId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/photos",
      path: {
        "carId": carId
      }
    });
  }
  /**
   * @param carId
   * @returns PhotoDto OK
   * @throws ApiError
   */
  photosGetUserPhotosByCarId(carId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/photos/currentusers",
      path: {
        "carId": carId
      }
    });
  }
}
class StagedActivitiesEndpointsService {
  constructor(httpRequest) {
    __publicField(this, "httpRequest");
    this.httpRequest = httpRequest;
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  stagedActivitiesBatchToActivities(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/stagedactivities/batchtoactivities",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param stagedActivityId
   * @returns any OK
   * @throws ApiError
   */
  stagedActivitiesDelete(stagedActivityId) {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/stagedactivities/{stagedActivityId}",
      path: {
        "stagedActivityId": stagedActivityId
      }
    });
  }
  /**
   * @param stagedActivityId
   * @param requestBody
   * @returns StagedActivityGetDto OK
   * @throws ApiError
   */
  stagedActivitiesPatch(stagedActivityId, requestBody) {
    return this.httpRequest.request({
      method: "PATCH",
      url: "/api/stagedactivities/{stagedActivityId}",
      path: {
        "stagedActivityId": stagedActivityId
      },
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param stagedActivityId
   * @param requestBody
   * @returns StagedActivityGetDto OK
   * @throws ApiError
   */
  stagedActivitiesPut(stagedActivityId, requestBody) {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/stagedactivities/{stagedActivityId}",
      path: {
        "stagedActivityId": stagedActivityId
      },
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param carId
   * @returns StagedActivityGetDto OK
   * @throws ApiError
   */
  stagedActivitiesGetCarStagedActivities(carId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/stagedactivities",
      path: {
        "carId": carId
      }
    });
  }
  /**
   * @param dealerId
   * @returns StagedActivityGetDto OK
   * @throws ApiError
   */
  stagedActivitiesGetDealersStagedActivities(dealerId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/dealers/{dealerId}/stagedactivities",
      path: {
        "dealerId": dealerId
      }
    });
  }
  /**
   * @param requestBody
   * @returns StagedActivityGetDto OK
   * @throws ApiError
   */
  stagedActivitiesPost(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/stagedactivities",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
}
class VehicleVideoEndpointsService {
  constructor(httpRequest) {
    __publicField(this, "httpRequest");
    this.httpRequest = httpRequest;
  }
  /**
   * @param dealerName
   * @param stockNumber
   * @returns any OK
   * @throws ApiError
   */
  vehicleVideoVideoDeletedEvent(dealerName, stockNumber) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/vehiclevideo/deleted/{dealerName}/{stockNumber}",
      path: {
        "dealerName": dealerName,
        "stockNumber": stockNumber
      }
    });
  }
  /**
   * @param dealerName
   * @param stockNumber
   * @param s3FileUrl
   * @returns any OK
   * @throws ApiError
   */
  vehicleVideoVideoUploadedEvent(dealerName, stockNumber, s3FileUrl) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/vehiclevideo/uploaded/{dealerName}/{stockNumber}/{s3FileUrl}",
      path: {
        "dealerName": dealerName,
        "stockNumber": stockNumber,
        "s3FileUrl": s3FileUrl
      }
    });
  }
}
class VideoEndpointsService {
  constructor(httpRequest) {
    __publicField(this, "httpRequest");
    this.httpRequest = httpRequest;
  }
  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  videosBatch(requestBody) {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/videos/batch",
      body: requestBody,
      mediaType: "application/json-patch+json"
    });
  }
  /**
   * @param videoId
   * @returns CarVideoGetDto OK
   * @throws ApiError
   */
  videosGet(videoId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/videos/{videoId}",
      path: {
        "videoId": videoId
      }
    });
  }
  /**
   * @param carId
   * @returns VideoDto OK
   * @throws ApiError
   */
  videosGetVideosByCarId(carId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/videos",
      path: {
        "carId": carId
      }
    });
  }
  /**
   * @param carId
   * @returns VideoDto OK
   * @throws ApiError
   */
  videosGetUserVideosByCarId(carId) {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/cars/{carId}/videos/currentusers",
      path: {
        "carId": carId
      }
    });
  }
}
class FieldServiceClient {
  constructor(config, HttpRequest = AxiosHttpRequest) {
    __publicField(this, "activitiesEndpoints");
    __publicField(this, "authEndpoints");
    __publicField(this, "carsEndpoints");
    __publicField(this, "dataOneEndpoints");
    __publicField(this, "dealersEndpoints");
    __publicField(this, "mediaCopierSettingsEndpoints");
    __publicField(this, "mediaUploadEndpoints");
    __publicField(this, "mediaUploadItemEndpoints");
    __publicField(this, "notShotEndpoints");
    __publicField(this, "optionsEndpoints");
    __publicField(this, "paperTrailEndpoints");
    __publicField(this, "photoEndpoints");
    __publicField(this, "stagedActivitiesEndpoints");
    __publicField(this, "vehicleVideoEndpoints");
    __publicField(this, "videoEndpoints");
    __publicField(this, "request");
    this.request = new HttpRequest({
      BASE: (config == null ? void 0 : config.BASE) ?? "",
      VERSION: (config == null ? void 0 : config.VERSION) ?? "1",
      WITH_CREDENTIALS: (config == null ? void 0 : config.WITH_CREDENTIALS) ?? false,
      CREDENTIALS: (config == null ? void 0 : config.CREDENTIALS) ?? "include",
      TOKEN: config == null ? void 0 : config.TOKEN,
      USERNAME: config == null ? void 0 : config.USERNAME,
      PASSWORD: config == null ? void 0 : config.PASSWORD,
      HEADERS: config == null ? void 0 : config.HEADERS,
      ENCODE_PATH: config == null ? void 0 : config.ENCODE_PATH
    });
    this.activitiesEndpoints = new ActivitiesEndpointsService(this.request);
    this.authEndpoints = new AuthEndpointsService(this.request);
    this.carsEndpoints = new CarsEndpointsService(this.request);
    this.dataOneEndpoints = new DataOneEndpointsService(this.request);
    this.dealersEndpoints = new DealersEndpointsService(this.request);
    this.mediaCopierSettingsEndpoints = new MediaCopierSettingsEndpointsService(this.request);
    this.mediaUploadEndpoints = new MediaUploadEndpointsService(this.request);
    this.mediaUploadItemEndpoints = new MediaUploadItemEndpointsService(this.request);
    this.notShotEndpoints = new NotShotEndpointsService(this.request);
    this.optionsEndpoints = new OptionsEndpointsService(this.request);
    this.paperTrailEndpoints = new PaperTrailEndpointsService(this.request);
    this.photoEndpoints = new PhotoEndpointsService(this.request);
    this.stagedActivitiesEndpoints = new StagedActivitiesEndpointsService(this.request);
    this.vehicleVideoEndpoints = new VehicleVideoEndpointsService(this.request);
    this.videoEndpoints = new VideoEndpointsService(this.request);
  }
}
const OpenAPI = {
  BASE: "",
  VERSION: "1",
  WITH_CREDENTIALS: false,
  CREDENTIALS: "include",
  TOKEN: void 0,
  USERNAME: void 0,
  PASSWORD: void 0,
  HEADERS: void 0,
  ENCODE_PATH: void 0
};
var CarPostResult;
(function(CarPostResult2) {
  CarPostResult2["FAILED"] = "Failed";
  CarPostResult2["CAR_ADDED"] = "CarAdded";
  CarPostResult2["CAR_RESTORED"] = "CarRestored";
  CarPostResult2["CAR_EXISTED"] = "CarExisted";
})(CarPostResult || (CarPostResult = {}));
var MediaFileType;
(function(MediaFileType2) {
  MediaFileType2["PHOTO"] = "Photo";
  MediaFileType2["VIDEO"] = "Video";
  MediaFileType2["AUDIO"] = "Audio";
})(MediaFileType || (MediaFileType = {}));
export {
  ActivitiesEndpointsService,
  ApiError,
  AuthEndpointsService,
  BaseHttpRequest,
  CancelError,
  CancelablePromise,
  CarPostResult,
  CarsEndpointsService,
  DataOneEndpointsService,
  DealersEndpointsService,
  FieldServiceClient,
  MediaCopierSettingsEndpointsService,
  MediaFileType,
  MediaUploadEndpointsService,
  MediaUploadItemEndpointsService,
  NotShotEndpointsService,
  OpenAPI,
  OptionsEndpointsService,
  PaperTrailEndpointsService,
  PhotoEndpointsService,
  StagedActivitiesEndpointsService,
  VehicleVideoEndpointsService,
  VideoEndpointsService
};
//# sourceMappingURL=fieldservice-client.es.js.map
